import {
  Categories,
  MomentCategories
} from '@dadohr/shared/domainTypes/experience';
import { compact } from 'lodash';

import { AutocompleteMultiFreeSolo } from '../../../../../components/Autocomplete';
import { ColoredChip } from '../../../../../components/ColoredChip';
import { FormRow } from '../../../../../components/Form/FormRow';
import { useUnsafeTranslation } from '../../../../../i18next';
import { FlexContainer } from '../../../../../layout/Flex';
import { CategoriesLabels } from '../../../services/templateTemplates';
import { EditComponentProps, ViewComponentProps } from '../types';

export const EditSectionCategories = ({
  value,
  onChange
}: EditComponentProps) => {
  const { t } = useUnsafeTranslation();
  return (
    <FormRow>
      <AutocompleteMultiFreeSolo
        label={t('Categories')}
        fullWidth
        value={compact(value.data.categories?.map((category) => category.type))}
        onChange={(next) => {
          const momentCategories: MomentCategories[] = next.map((next) => {
            return {
              type: next as Categories,
              label: CategoriesLabels[next as Categories](t)
            };
          });
          return onChange({
            ...value,
            data: {
              ...value.data,
              categories: momentCategories
            }
          });
        }}
        options={Object.values(Categories)}
        getOptionLabel={(option) => CategoriesLabels[option as Categories](t)}
      />
    </FormRow>
  );
};

export const ViewSectionCategories = ({ value }: ViewComponentProps) => {
  return (
    <FlexContainer>
      {value.data.categories.map((category) => (
        <ColoredChip color="gray">{category.label}</ColoredChip>
      ))}
    </FlexContainer>
  );
};
